/* eslint-disable react/jsx-no-bind */

import React from 'react';
import styled from 'styled-components';
import Network from 'react-network';
import { navbarHeight } from 'shared/components/layout/app-layout';
import Emoji from 'shared/components/emoji';

const StyledContainer = styled.div`
  align-items: center;
  background-color: red;
  color: white;
  display: flex;
  font-weight: 700;
  height: ${navbarHeight};
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;

const StyledOverlay = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  bottom: 0;
  color: white;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  text-align: center;
  top: ${navbarHeight};
  z-index: 10;
`;

const OfflineDetection = () => (
  <Network
    render={({ online }) => {
      if (!online) {
        return (
          <StyledOverlay>
            <StyledContainer>Offline</StyledContainer>
            <div>
              <Emoji size="largest" mb={1}>
                😟
              </Emoji>
              <div>Lost internet connection</div>
            </div>
          </StyledOverlay>
        );
      }

      return null;
    }}
  />
);

export default OfflineDetection;
